import { useSyncExternalStore, type JSX } from 'react';

import { toasts } from './toastStore';

export function Toasts(): JSX.Element {
  const items = useSyncExternalStore(
    (listener) => toasts.subscribe(listener),
    () => toasts.get().items,
    () => toasts.get().items,
  );
  return (
    <div id="toasts" role="status" aria-live="polite">
      {items.map((item) => (
        <div key={item.id} className={`toast${item.big ? ' big' : ''}${item.out ? ' out' : ''}`}>
          {item.text}
        </div>
      ))}
    </div>
  );
}
